import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-595b7618"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = ["innerHTML"]

import CusModal from "@component/CusModal/index.vue";
import { useLayoutDataStore } from "@/store/layoutData";
import { useloginStore } from "@/store/login";
import { storeToRefs } from "pinia";
import { trackCustomizeEvent } from "@/js/stastic";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const layoutDataStore = useLayoutDataStore();
const loginStore = useloginStore();
const { webVersionUpdateModal } = storeToRefs(layoutDataStore);
const { webPopupNoticeConfig } = storeToRefs(loginStore);
const handleClose = () => {
  layoutDataStore.updateStateProp("webVersionUpdateModal", false);
  trackCustomizeEvent({
    event_id: "chikiiweb-version-modal-click",
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CusModal, {
    isShow: _unref(webVersionUpdateModal),
    okText: "OK",
    onOnClose: handleClose,
    onOnConfirm: handleClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(webPopupNoticeConfig).title), 1),
        _createElementVNode("p", {
          class: "content",
          innerHTML: _unref(webPopupNoticeConfig).content
        }, null, 8, _hoisted_3)
      ])
    ]),
    _: 1
  }, 8, ["isShow"]))
}
}

})